import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.project.document.add');
import { OnInit, Input, Output, EventEmitter, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-component-project-document-add',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.project.document.add/view.scss */
:host {
  display: block;
}`],
})
export class ComponentProjectDocumentAddComponent implements OnInit {
    @Input() isOpen: boolean = false;
    @Input() projectId: string = '';
    @Output() onClose = new EventEmitter<void>();
    @Output() onUploaded = new EventEmitter<void>();

    public files: File[] = [];
    public isUploading: boolean = false;
    public uploadProgress: number = 0;
    public isDragOver: boolean = false;

    private readonly allowedExtensions: string[] = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'hwp', 'hwpx', 'txt', 'zip'];

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() { }

    public close() {
        this.files = [];
        this.uploadProgress = 0;
        this.isDragOver = false;
        this.onClose.emit();
    }

    private getExtension(fileName: string): string {
        if (!fileName.includes('.')) return '';
        return fileName.toLowerCase().split('.').pop() || '';
    }

    private isAcceptedDocument(file: File): boolean {
        return this.allowedExtensions.includes(this.getExtension(file.name));
    }

    private async appendFiles(fileList: FileList | File[]) {
        for (const file of Array.from(fileList)) {
            if (!this.isAcceptedDocument(file)) continue;
            const exists = this.files.some(item => item.name === file.name && item.size === file.size);
            if (!exists) this.files.push(file);
        }
        await this.service.render();
    }

    public async onFileChange(event: any) {
        const fileList = event.target.files;
        if (!fileList?.length) return;
        await this.appendFiles(fileList);
        event.target.value = '';
    }

    public onDragOver(event: DragEvent) {
        event.preventDefault();
        this.isDragOver = true;
        this.ref.detectChanges();
    }

    public onDragLeave(event: DragEvent) {
        event.preventDefault();
        this.isDragOver = false;
        this.ref.detectChanges();
    }

    public async onDrop(event: DragEvent) {
        event.preventDefault();
        this.isDragOver = false;
        const fileList = event.dataTransfer?.files;
        if (!fileList?.length) {
            await this.service.render();
            return;
        }
        await this.appendFiles(fileList);
    }

    public async removeFile(index: number) {
        this.files.splice(index, 1);
        await this.service.render();
    }

    public formatFileSize(bytes: number): string {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    public getFileIconClass(file: File): string {
        const extension = this.getExtension(file.name);
        if (extension === 'pdf') return 'fa-solid fa-file-pdf text-red-400';
        if (['doc', 'docx', 'hwp', 'hwpx'].includes(extension)) return 'fa-solid fa-file-word text-blue-400';
        if (['xls', 'xlsx'].includes(extension)) return 'fa-solid fa-file-excel text-emerald-400';
        if (['ppt', 'pptx'].includes(extension)) return 'fa-solid fa-file-powerpoint text-orange-400';
        if (extension === 'zip') return 'fa-solid fa-file-zipper text-amber-400';
        return 'fa-solid fa-file-lines text-slate-400';
    }

    public async upload() {
        if (this.files.length === 0) return;

        this.isUploading = true;
        this.uploadProgress = 0;
        await this.service.render();

        const fd = new FormData();
        fd.append('project_id', this.projectId);
        for (const file of this.files) {
            fd.append('file[]', file);
        }

        try {
            await new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('POST', wiz.url('upload_documents'));

                xhr.upload.onprogress = (e: ProgressEvent) => {
                    if (e.lengthComputable) {
                        this.uploadProgress = Math.round((e.loaded / e.total) * 100);
                        this.service.render();
                    }
                };

                xhr.onload = () => {
                    try {
                        const data = JSON.parse(xhr.responseText);
                        if (xhr.status === 200) {
                            resolve(data);
                        } else {
                            reject(new Error(data.message || data.data || '업로드 실패'));
                        }
                    } catch {
                        reject(new Error('응답 처리 실패'));
                    }
                };

                xhr.onerror = () => reject(new Error('네트워크 오류'));
                xhr.send(fd);
            });

            this.files = [];
            this.isUploading = false;
            this.uploadProgress = 0;
            await this.service.render();
            this.onUploaded.emit();
            this.onClose.emit();
            await this.service.alert.show({
                title: '성공',
                message: '계약 관련 서류가 업로드되었습니다.',
                status: 'success',
                action: '확인',
                cancel: false
            });
        } catch (e: any) {
            this.isUploading = false;
            this.uploadProgress = 0;
            await this.service.render();
            await this.service.alert.show({
                title: '오류',
                message: e.message || '업로드에 실패했습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
        }
    }
}

export default ComponentProjectDocumentAddComponent;